import { PickupPointWeb } from "./web";
import { PickupPointBlockProps } from "./types";

export function PickupPointWebEditor(props: PickupPointBlockProps) {
  return <PickupPointWeb {...props} />;
}
